import React from 'react';
import PropTypes from 'prop-types';
import makeRef from 'lib/makeRef';
import './view-with-sidebar.scss';

export default class ViewWithSidebar extends React.Component {
  static propTypes = {
    hasStickySidebar: PropTypes.bool,
    sidebarItems: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        content: PropTypes.node
      })
    ).isRequired,
    mainItems: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        content: PropTypes.node
      })
    ).isRequired
  };

  constructor() {
    super();

    this.navHeight = 0;
    this.parentOffset = 0;
  }

  componentDidMount() {
    if (this.props.hasStickySidebar) {
      const commonContent = global.document.querySelector('.common-content');
      this.navHeight = parseInt(global.getComputedStyle(commonContent).paddingTop, 10);
      this.parentOffset = this.calculateParentOffset();
      global.addEventListener('scroll', this.optimizedSetPosition);
    }
  }

  componentWillUnmount() {
    global.removeEventListener('scroll', this.optimizedSetPosition);
  }

  makeRef = makeRef.bind(this);

  calculateParentOffset() {
    let element = this.sidebar; // something more performant
    let distanceFromTop = 0;
    while (element) {
      distanceFromTop += element.offsetTop - element.scrollTop + element.clientTop;
      element = element.offsetParent;
    }

    return distanceFromTop;
  }

  optimizedSetPosition = () => {
    global.requestAnimationFrame(this.setPosition);
  };

  setPosition = () => {
    const scrollPosition = global.scrollY;

    const windowHeight = global.document.documentElement.scrollHeight;
    const wrapperHeight = global.document.querySelector('.common-content').clientHeight;
    const footerHeight = windowHeight - wrapperHeight;

    const offset = this.parentOffset - this.navHeight - 14; // Approximate the margin
    const remainingScrollArea = wrapperHeight - scrollPosition;

    const sidebar = this.sidebar;
    const stickyClass = 'view-with-sidebar__sidebar--sticky';

    if (scrollPosition > offset) {
      // add class
      if (!sidebar.classList.contains(stickyClass)) {
        sidebar.classList.add(stickyClass);
      }
      if (this.sidebar.clientHeight < remainingScrollArea) {
        this.sidebar.style.top = this.navHeight + 'px';
      } else {
        this.sidebar.style.top = wrapperHeight - this.sidebar.clientHeight - footerHeight + 'px';
      }
    } else {
      sidebar.classList.remove(stickyClass);
      this.sidebar.style.top = '0px';
    }
  };

  makeItems(items) {
    return items.map((item, i) => {
      return (
        <div className='view-with-sidebar__item-wrapper' key={i}>
          <h2 className='card-label'>{item.label || <span>&nbsp;</span>}</h2>
          {item.content}
        </div>
      );
    });
  }

  render() {
    return (
      <div className='view-with-sidebar max-width'>
        <div className='view-with-sidebar__sidebar' data-ref-name='sidebar' ref={this.makeRef}>
          {this.makeItems(this.props.sidebarItems)}
        </div>
        <div className='view-with-sidebar__main'>{this.makeItems(this.props.mainItems)}</div>
      </div>
    );
  }
}
